import { FC } from "react";
import db from "../../../db";
import Button from "../../../styles/components/Button";

const ProductTab: FC = () => {
  const getProductBySkuOrParentSkuOrVariantSku = async (sku: string) => {
    try {
      const withParentSku = db
        .collection("products")
        .where("parentSKU", "==", sku)
        .get();
      const withSku = db.collection("products").where("sku", "==", sku).get();
      const withVariantSku = db
        .collectionGroup("productvariants")
        .where("sku", "==", sku)
        .get();

      const [parentSkulSnap, skuSnap, variantSkuSnap] = await Promise.all([
        withParentSku,
        withSku,
        withVariantSku,
      ]);
      const parentData = parentSkulSnap.docs.length
        ? parentSkulSnap.docs.map((doc) => ({ ...doc.data() }))
        : [];
      const skuData = skuSnap.docs.length
        ? skuSnap.docs.map((doc) => ({ ...doc.data() }))
        : [];
      const variantData = variantSkuSnap.docs.length
        ? variantSkuSnap.docs.map((doc) => ({ ...doc.data() }))
        : [];

      return [...parentData, ...skuData, ...variantData];
    } catch (error: any) {
      console.log(error.toString ? error.toString() : error);
    }
  };

  return (
    <>
      <Button
        className="btn btn-lg btn-primary fw-bolder"
        onClick={async () => {
          const data = await getProductBySkuOrParentSkuOrVariantSku("12345811");
          console.log(data);
        }}
      >
        Get Product or Variant SKU
      </Button>
      <br />
    </>
  );
};

export default ProductTab;
